import { EUserType, TUserDataUi } from 'data/types/user.types';
import { useAppSelector } from 'redux/store';

const ADMIN_TYPES = [
  EUserType.READY_ADMIN,
  EUserType.SUPER_ADMIN,
  EUserType.ELC_LEAD,
];

export const useIsAdminUser = (): boolean => {
  const usersData: TUserDataUi = useAppSelector(state => state.userSlice.user);

  if (!usersData) return false;

  return usersData.type.some(type => ADMIN_TYPES.includes(type));
};
